import { Button } from 'react-bootstrap';
import { Chat } from 'react-bootstrap-icons';
import classNames from 'classnames';

import { createUseThemedStyles } from '@/hooks';
import { focus } from '@/jss/mixins';

const useStyles = createUseThemedStyles((theme) => ({
	aiExampleQuestion: {
		border: 0,
		padding: 15,
		width: '100%',
		display: 'flex',
		borderRadius: 5,
		textAlign: 'left',
		position: 'relative',
		alignItems: 'center',
		backgroundColor: theme.colors.gray100,
		'&:after': {
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			borderRadius: 'inherit',
			content: '""',
			position: 'absolute',
			pointerEvents: 'none',
			border: `1px solid ${theme.colors.gray300}`,
		},
		'&:hover': {
			backgroundColor: theme.colors.gray200,
		},
		'&:active': {
			backgroundColor: theme.colors.gray300,
		},
		'&:focus': {
			outline: 'none',
		},
		'&:focus-visible': {
			...focus(theme.colors.primary),
			'&:after': {
				border: 0,
			},
		},
	},
}));

interface AiExampleQuestionProps {
	question: string;
	onClick(question: string): void;
	className?: string;
}

export const AiExampleQuestion = ({ question, onClick, className }: AiExampleQuestionProps) => {
	const classes = useStyles();

	return (
		<Button
			bsPrefix="ai-example-question"
			className={classNames(classes.aiExampleQuestion, className)}
			onClick={() => {
				onClick(question);
			}}
		>
			<Chat className="mr-2 text-primary flex-shrink-0" width={20} height={20} />
			<p className="mb-0">{question}</p>
		</Button>
	);
};
